export default __webpack_public_path__ + "static/media/WhatsApp Community_Ajman.3d126fba.png";